import { Box, FormLabel } from '@chakra-ui/react'
import { ContractDocType } from 'BrokerTsLib/src/enums'

import { Loading } from '../../components/Loading'
import { useAuth } from '../../context/AuthContext'
import { useGetAllDocuments } from '../../hooks/useDocuments'
import { DownloadButton } from '../DownloadButton'
import { InsuranceUpload } from './InsuranceUpload'

export const InsuranceDownloads = ({
  paramsId,
  insurerOfferId,
  title = 'Dokumenty a informace k pojištění',
}: {
  paramsId: string
  insurerOfferId: number
  title?: string
}) => {
  const auth = useAuth()
  const { data, refetch, isLoading } = useGetAllDocuments(paramsId, insurerOfferId)
  const allDocuments = data?.data ?? []

  const mergedDoc = allDocuments?.find((x) => x.type === ContractDocType.MergedDocuments)
  const nonLegalDocs =
    allDocuments?.filter((x) => !x.isLegalType && x.type !== ContractDocType.MergedDocuments) ?? []
  const legalDocs =
    allDocuments?.filter((x) => x.isLegalType && x.type !== ContractDocType.MergedDocuments) ?? []

  return (
    <Box sx={{ display: 'grid', gap: 8, placeItems: 'start' }}>
      {isLoading && <Loading />}

      {!isLoading && (
        <>
          <Box sx={{ display: 'grid', gap: 4, placeItems: 'start' }}>
            <FormLabel>{title}</FormLabel>

            {mergedDoc && (
              <DownloadButton isDownloadAll as="a" href={mergedDoc.url} target="_blank">
                Stáhnout kompletní dokumentaci
              </DownloadButton>
            )}

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { base: '1fr', md: '1fr 1fr' },
                placeContent: 'start',
                placeItems: 'start',
                gap: 2,
              }}
            >
              {nonLegalDocs.map((x) => (
                <DownloadButton key={x.url} as="a" href={x.url} target="_blank">
                  {x.description}
                </DownloadButton>
              ))}
            </Box>
          </Box>

          {legalDocs.length > 0 && (
            <Box sx={{ display: 'grid', gap: 4, placeItems: 'start' }}>
              <FormLabel>Právní dokumenty k pojištění</FormLabel>

              {legalDocs.map((x) => (
                <DownloadButton key={x.url} as="a" href={x.url} target="_blank">
                  {x.description}
                </DownloadButton>
              ))}
            </Box>
          )}

          {auth?.user?.allowUploadInsuranceDocuments && (
            <InsuranceUpload
              offerId={insurerOfferId}
              existingDocuments={allDocuments}
              onUpload={refetch}
            />
          )}
        </>
      )}
    </Box>
  )
}
